/**
 * CONODATA
 * Copyright (c) 2025 Cognoware Cia. Ltda.
 * Todos los derechos reservados.
 * <p>
 * Este archivo forma parte del Sistema de Votación Electrónica de
 * Cognoware Cia. Ltda, desarrollado conforme a los requerimientos y
 * normativas establecidos.
 */
/**
 * Define los tipos de acción Redux del módulo Comportamiento de Pago.
 *
 * Centraliza constantes para operaciones de importación, consulta,
 * edición, activación, desactivación y reseteo de estado.
 *
 * @author DSISALIMA
 * @version 1.0.0
 * @since 2026-02-18
 */
// Importacion Excel 
export const LOADING_CP_IMPORT = 'LOADING_CP_IMPORT'
export const SUCCESS_CP_IMPORT = 'SUCCESS_CP_IMPORT'
export const ERROR_CP_IMPORT = 'ERROR_CP_IMPORT'

// Resumen de importacion
export const LOADING_CP_IMPORT_SUMMARY = 'LOADING_CP_IMPORT_SUMMARY'
export const SUCCESS_CP_IMPORT_SUMMARY = 'SUCCESS_CP_IMPORT_SUMMARY'
export const ERROR_CP_IMPORT_SUMMARY = 'ERROR_CP_IMPORT_SUMMARY'

// Errores de importacion paginados 
export const LOADING_CP_IMPORT_ERRORS = 'LOADING_CP_IMPORT_ERRORS'
export const SUCCESS_CP_IMPORT_ERRORS = 'SUCCESS_CP_IMPORT_ERRORS'
export const ERROR_CP_IMPORT_ERRORS = 'ERROR_CP_IMPORT_ERRORS'

export const LOADING_CP_ADMIN_LIST = 'LOADING_CP_ADMIN_LIST'
export const SUCCESS_CP_ADMIN_LIST = 'SUCCESS_CP_ADMIN_LIST'
export const ERROR_CP_ADMIN_LIST = 'ERROR_CP_ADMIN_LIST'

// Editar registro (PUT /{idPersona})
export const LOADING_CP_EDIT = 'LOADING_CP_EDIT'
export const SUCCESS_CP_EDIT = 'SUCCESS_CP_EDIT'
export const ERROR_CP_EDIT = 'ERROR_CP_EDIT'

// Desactivar registro (DELETE /{idPersona})
export const LOADING_CP_DEACTIVATE = 'LOADING_CP_DEACTIVATE'
export const SUCCESS_CP_DEACTIVATE = 'SUCCESS_CP_DEACTIVATE'
export const ERROR_CP_DEACTIVATE = 'ERROR_CP_DEACTIVATE'

// Activar registro (PATCH /{idPersona}/activar)
export const LOADING_CP_ACTIVATE = 'LOADING_CP_ACTIVATE'
export const SUCCESS_CP_ACTIVATE = 'SUCCESS_CP_ACTIVATE'
export const ERROR_CP_ACTIVATE = 'ERROR_CP_ACTIVATE'

// Reset
export const RESET_CP_STATE = 'RESET_CP_STATE'
export const RESET_CP_OPERATION = 'RESET_CP_OPERATION'
